import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutomaticDebitService } from '../../services/automatic-debit.service';
import { AutomaticDebitDataReceiving, AutomaticDebitRetFile } from '../../models/automaticDebitRetFile';
import { NotificationsService } from 'angular2-notifications';
import * as _ from 'lodash';
import { AppConfig } from 'src/app/core/_config/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileService } from 'src/app/services/file.service';
import { AutomaticDebitFileRetStatus, FileType } from '../../models/inputModels';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { forkJoin, Observable } from 'rxjs';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { ModalConfig } from 'src/app/models/modalConfig';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kt-automatic-debit-selec-file',
    templateUrl: './automatic-debit-selec-file.component.html',
    styleUrls: ['./automatic-debit-selec-file.component.scss'],
})
export class AutomaticDebitSelecFileComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private automaticDebitService: AutomaticDebitService,
        private notificationsService: NotificationsService,
        private router: Router,
        private _config: AppConfig,
        private _cdRef: ChangeDetectorRef,
        private spinner: NgxSpinnerService,
        private fileService: FileService,
        private authServiceCustom: AuthServiceCustom,
        private _dialog: MatDialog,
        private sessionBusiness: SessionBusiness
    ) {}

    dateAccountingStr:string;

    fileSelected: AutomaticDebitRetFile = null;
    dataReceivingList: AutomaticDebitDataReceiving[] = [];
    guidEmpt = '00000000-0000-0000-0000-000000000000';

    breadcrumbItems = [
        { label: 'Arquivos REM', route: 'automatic-debit/rem', active: false },
        { label: 'Arquivos RET', route: 'automatic-debit/ret', active: false },
        { label: 'Arquivo Selecionado', active: true },
        { label: 'Importar RET', route: 'automatic-debit/ret/import', active: false },
    ];
    totalFile: number;
    idParam: string;
    paramId: string;
    enableBtnProcess: boolean = false;

    // Select options for return actions
    selectOptions = [
        { id: 1, name: 'Receber' }, // Direct receive action
        { id: 2, name: 'Receber outro boleto' }, // Open modal
        { id: 3, name: 'Resolver' }, // Resolve pendency
    ];

    openbilletsFromResponsible: ModalConfig = {
        status: false,
        typeSolution: 0,
        element: {},
    };

    ngOnInit(): void {
        this.getMothAccounting();
        this.route.queryParams.subscribe((params) => {
            this.paramId = params['id'];
            if (this.paramId) {
                this.loadFile(this.paramId);
            }
        });
    }

    getMothAccounting(){
       this.automaticDebitService.GetAccountingMonth(this.sessionBusiness.LegalEntityIdContext)
       .subscribe((p) => {
            let result = p.data;
            let date = new Date(result.year,result.month,1);
            this.dateAccountingStr = this.formatYYYYMMDD(date);   
        });        
    }

    formatYYYYMMDD(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    loadFile(id: string) {
        this.spinner.show();
        this.automaticDebitService.GetRetFile(id).subscribe(
            (result) => {
                if (result.success) {
                    this.setfileSelected(result.data);
                    this.setTotalFile();
                    this.allReceiving();
                    this.spinner.hide();
                    this._cdRef.detectChanges();
                } else {
                    console.error(result);
                    this.spinner.hide();
                    this.notificationsService.warn('Erro: verifique o console');
                }
            },
            (error) => {
                this.router.navigate(['automatic-debit/import']);
                console.error(error);
            },
        );
    }

    setTotalFile(): void {
        let values = this.dataReceivingList?.map((x) => x.billetValue);
        this.totalFile = _.sum(values);
    }

    setfileSelected(data: AutomaticDebitRetFile): void {
        this.fileSelected = data;
        this.dataReceivingList = this.fileSelected.dataReceiving.items;
    }

    goToBillet(billetId: string) {
        if (billetId == this.guidEmpt) {
            this.notificationsService.warn('Boleto não foi encontrado');
            return;
        }
        this.redirect(`${this._config.urlOldAfs}AccountsReceiving/AccountsReceiving/?BilletId=${billetId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }

    downloadFile(file: AutomaticDebitRetFile) {
        this.spinner.show();

        this.automaticDebitService.DownloadFile(file.id, FileType.Ret).subscribe(
            (response) => {
                this.fileService.downloadFile(response);
                this.notificationsService.success(`Download completo!`);
                this.spinner.hide();
            },
            (error) => {
                console.error('Erro', error);
                this.spinner.hide();
            },
        );
    }

    btnReceivingLine(line: AutomaticDebitDataReceiving) {
        if (parseInt(line.returnCode) != AutomaticDebitFileRetStatus.Efetuado) {
            this.notificationsService.warn(`Item seleconado possui pendência`);
            return;
        }

        this.sendToReceiving(line.lineId);
    }

    showButtonReceiving(line: AutomaticDebitDataReceiving): boolean {
        if (line.received) {
            return false;
        }
        if (parseInt(line.returnCode) != AutomaticDebitFileRetStatus.Efetuado) {
            return false;
        }
        return true;
    }

    btnResolveLine(line: AutomaticDebitDataReceiving) {
        if (!line?.billetNumber || line.billetId == this.guidEmpt) {
            this.notificationsService.warn(`Parcela não foi Localizada`);
            return;
        }

        if (!line?.isPendency) {
            this.notificationsService.warn(`Não possui pendência`);
            return;
        }

        this.yesOrNoDialog(
            'Confirmar Processamento do arquivo ?',
            `<br> O Item pendente irá voltar a Parcela <strong> ${line.billetNumber} </strong> como Ativa`,
        ).subscribe((result) => {
            if (result) {
                this.spinner.show();
                this.automaticDebitService.ResolvePendencyLineId(this.fileSelected.id, line.lineId).subscribe(() => {
                    this.loadFile(this.paramId);
                    this.spinner.hide();
                });
            }
        });
    }

    refreshStatusFile() {
        this.spinner.show();
        this.automaticDebitService.RefreshStatusFile(this.fileSelected.id).subscribe(() => {
            this.loadFile(this.paramId);
            this.spinner.hide();
        });
    }

    btnProcessFile() {
        let qtdReceived = this.dataReceivingList.filter((x) => x.received).length;
        let qtdToReceiving = this.dataReceivingList.filter((x) => !x.received).length;

        if (qtdToReceiving == 0) {
            this.notificationsService.warn(`Não há itens para Processar`);
            return;
        }

        if (qtdToReceiving != qtdReceived) {
            let message = `
            <span class='text-primary'> Efetuado : </span> = Enviado para Recebimento <br>
            <span class='text-primary'> Pendencias: </span> Enviar para Alteração de Status (Ativo)  `;
            this.yesOrNoDialog('Confirmar Processamento do arquivo ?', message).subscribe((result) => {
                if (result) {
                    this.sendToReceiving();
                }
            });
        } else {
            this.notificationsService.warn(`Todos os itens já foram recebidos`);
            return;
        }
    }

    private sendToReceiving(lineId?: string) {
        if (lineId) {
            this.confirmSendToReceiving(lineId);
        } else {
            this.processAll();
        }
    }

    public allReceiving(): boolean {
        let qtdReceived = this.dataReceivingList.filter((x) => x.received).length;
        let qtdToReceiving = this.dataReceivingList.filter((x) => !x.received).length;

        if (qtdToReceiving == qtdReceived) {
            this.enableBtnProcess = true;
            return true;
        }

        if (qtdToReceiving != 0) {
            if (this.dataReceivingList.filter((x) => x.isPendency).length == 0) {
                this.enableBtnProcess = true;
                return true;
            } else {
                this.enableBtnProcess = false;
                return false;
            }
        } else {
            this.enableBtnProcess = true;
            return true;
        }
    }

    public btnAccountingFile() {
        let username = this.authServiceCustom.userName;
        this.yesOrNoDialog('Confirmar Contabilização do arquivo', 'Iniciar contabilização?').subscribe((result) => {
            if (result) {
                this.spinner.show();
                this.automaticDebitService.accountingRetFile(this.fileSelected.id, username).subscribe((result) => {
                    this.refreshStatusFile();
                    this.spinner.hide();
                });
            }
        });
    }

    private processAll() {
        let username = this.authServiceCustom.userName;

        this.spinner.show();
        const requests = this.dataReceivingList
            .filter((x) => x.billetId != this.guidEmpt)
            .map((item) => this.automaticDebitService.Receiving(this.fileSelected.id, username, item.lineId));

        forkJoin(requests).subscribe({
            next: (_) => {
                this.spinner.hide();
                this.refreshStatusFile();
            },
            error: (error) => {
                console.error(error);
                this.spinner.hide();
                this.refreshStatusFile();
            },
        });
    }

    private confirmSendToReceiving(lineId: string) {
        let username = this.authServiceCustom.userName;
        this.spinner.show();
        this.automaticDebitService.Receiving(this.fileSelected.id, username, lineId).subscribe(
            (result) => {
                if (result.success) {
                    this.notificationsService.success(`Recebido com sucesso`);
                }
                this.spinner.hide();
                this.loadFile(this.paramId);
            },
            (error) => {
                this.spinner.hide();
                this.loadFile(this.paramId);
                console.error(error);
            },
        );
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    returnSelect(ev: any) {
        const typeSolution = parseInt(ev.typeSolution);
        switch (typeSolution) {
            case 1:
                this.btnReceivingLine(ev.element);
                break;
            case 2:
                // Build a complete ModalConfig for the modal
                const line = ev.element;
                this.automaticDebitService.GetBilletData(line.billetId).subscribe((billetData) => {
                    let billet = billetData.data[0];

                    const modalConfig: ModalConfig = {
                        status: true,
                        typeSolution: 2,
                        element: {
                            id: line.lineId,
                            responsibleId: billet.responsibleId,
                            responsibleName: billetData.responsibleName,
                            billetNumber: line.billetNumber,
                            valuePaid: line.receivedValue,
                            billetValue: line.billetValue,
                            creditDate: line.lineDate,
                            dataReceiving: [
                                {
                                    billetNumber: billet.number,
                                    billetIdExternal: line.billetId,
                                },
                            ],
                        },
                    };

                    if (billet.statusBillingId == 1) modalConfig.element['error'] = 3; // Cancelado
                    this.openBillets(modalConfig);
                });
                break;
            default:
                this.btnResolveLine(ev.element);
                break;
        }
    }

    openBillets(param: ModalConfig) {
        this.openbilletsFromResponsible = param;
        this._cdRef.detectChanges();
    }

    onReturnElement(event: any) {
        // Find the index of the line to update
        const idx = this.dataReceivingList.findIndex((x) => x.lineId === event.receivingLineId);
        if (idx === -1) return;

        if (event.type === 1 && event.descriptionBillets) {
            const selectedBillets = event.billetsSelected.map((selected) => {
                // Find matching description
                const desc = event.descriptionBillets.find(
                    (d) => d.billetIdExternal === selected || d.number === selected.billetNumber,
                );
                return {
                    BilletNumber: desc ? desc.number : undefined,
                    BilletIdExternal: selected,
                };
            });

            this.dataReceivingList[idx].selectedBillets = selectedBillets;

            this.sendSelectedBillets(this.dataReceivingList[idx]);
        }

        this._cdRef.detectChanges();
    }

    sendSelectedBillets(line: AutomaticDebitDataReceiving) {
        const username = this.authServiceCustom.userName;
        const payload = {
            FileRetId: this.fileSelected.id,
            LineId: line.lineId,
            Username: username,
            SelectedBillets: line.selectedBillets,
        };

        this.automaticDebitService.ReceivingOtherBillets(payload).subscribe(
            (result) => {
                if (result.success) {
                    this.notificationsService.success('Boleto alterado com sucesso');
                    this.loadFile(this.paramId);
                } else {
                    this.notificationsService.warn('Erro ao alterar boleto');
                }
            },
            (error) => {
                this.notificationsService.warn('Erro ao alterar boleto');
                console.error(error);
            },
        );
    }
}
